export default {
  version: 'Версия',
  'build-date': 'Дата сборки',
  navbar: {
    logOut: 'Выйти',
    language: 'Сменить язык',
    screenfull: 'Во весь экран',
    theme: 'Тема'
  },
  login: {
    title: 'ВЫСОТА',
    user: 'Пользователь',
    password: 'Пароль',
    rememberme: 'Запомнить',
    forgetPassword: 'Забыли пароль?',
    codeSent: 'На Вашу почту отправлена информация по новому паролю',
    newPasswordSent: 'На Вашу почту отправлен новый пароль',
    code: 'Код подтверждения',
    changePassword: 'Создать пароль',
    passwordRecovery: 'Страница восстановления пароля',
    comebackToLogin: 'Вернуться на страницу логина',
    signin: 'Войти',
    undefined: 'Ошибка авторизации',
    AuthenticationError: {
      wrongUsernameOrPassword: 'Неверный пользователь или пароль',
      passwordExpired: 'Срок действия пароля истек. Новый пароль отправлен вам по электронной почте',
    },
    ConcurrentSessionControlAuthenticationStrategy: {
      'exceededAllowed': 'Превышен лимит одновременных авторизаций'
    },
    LogoutByIdleTimeout: 'Сессия завершена после 15 мин неактивности',
    'organization-not-set': 'Организация не указана',
    WrongPasswordRecoveryInfo: 'Указана неверная информация для восстановления'
  },
  user: {
    'hello-message-X': 'Добро пожаловать, {name}!',
    'my-roles': 'Мои роли'
  },
  common: {
    addButton: 'Добавить',
    search: 'Поиск...',
    save: 'Сохранить',
    cancel: 'Отмена',
    deleteQuestion: 'Удалить?',
    delete: 'Удалить',
    apply: 'Применить',
    emptyList: 'Записи не найдены',
    id: 'ИД',
    code: 'Код',
    type: 'Тип',
    displayName: 'Отображаемое имя',
    description: 'Описание',
    value: 'Значение',
    updated: 'Обновлено',
    version: 'Версия',
    export: 'Экспортировать',
    terminate: 'Остановить',
    restart: 'Перезапустить',
    dropXclFile: 'Загрузить excel файл',
    of: 'из',
    select: 'Выбрать',
    selected: 'Выбрано',
    approve: 'Согласовать',
    reject: 'Отклонить',
    refresh: 'Обновить',
    editMode: 'Режим редактирования',
    recent: 'Недавние',
    'message-box': {
      'submit': 'Подтвердить',
      'cancel': 'Отмена',
      'confirm-common-label': 'Подтвердите действие'
    },
    flightDate: 'Дата вылета',
    company: 'Компания',
    'process-diagram': 'Диаграмма процесса',
    attention: 'Внимание',
    show: 'Показать',
    hide: 'Скрыть',
    'preview-title-x': 'Предпросмотр: {label}',
    hhmm: 'ЧЧ:ММ',
    comments: 'Комментарии',
    browse: 'Обзор',
    selectDB: 'Выберите Базу данных',
    eticket: 'Квитанция'
  },
  bpm: {
    'startFormDefined': 'Старт-форма',
    'suspended-true': 'Приостановлено',
    'suspended-false': 'Активно'
  },
  main: {
    title: 'Главная'
  },
  filter: {
    select: 'Выберите',
    all: 'Все',
    any: 'Любой'
  },
  'flight-orders': {
    'dev-title': '[DEV] Заказы на перевозку',
    'title': 'Заказы на перевозку',
    'Initiator': 'Инициатор',
    'Author': 'Автор',
    'SelectInitiator': 'Выберите инициатора',
    'SelectDepPort': 'Выберите пункт отправления',
    'SelectArrPort': 'Выберите пункт прибытия',
    'DepPort': 'Пункт отправления',
    'ArrPort': 'Пункт прибытия',
    'depDate': 'Дата отправления',
    'dateTo': 'Дата прибытия',
    'no-order-items-in-uploaded-file': 'В загруженном файле заказы не определены',
    'no-paxes-in-uploaded-file': 'В загруженном файле не определены пассажиры',
    'choose-flight-order': 'Выберите группу заказов',
    'totalOrderItems': 'Заказов:',
    'createdBy': 'Создано',
    'source': 'Источник:',
    'choose-order-for-edit': 'Выберите заказ для редактирования',
    'addPassenger': 'Добавить пассажира',
    'addCargo': 'Добавить груз',
    passenger: 'Пассажир',
    cargo: 'Груз',
    'pax-list-title': 'Люди',
    'cargo-list-title': 'Грузы',
    'all-matches': 'Все совпадения',
    'no-orders-found': 'Нет заказов',
    'header-persons': 'Люди',
    'header-cargoes': 'Грузы',
    'flight-date': 'Дата вылета',
    'priority-up': 'Повысить приоритет',
    'priority-down': 'Понизить приоритет',
    'group-orders': 'Сгруппировать',
    'ungroup-orders': 'Разгруппировать',
    'geo-points-count': 'Неуточнённых геоточек',
    'geo-points-set': 'Уточнение геоточек',
    'geo-points-from': 'Порт вылета',
    'geo-points-to': 'Порт прибытия',
    'geo-points-exist': 'Выбрать из существующих',
    'geo-points-new': 'Создание новой геоточки',
    'geo-points-is-exist': 'Такой код существует',
    'geo-points-create': 'Создать',
    'geo-points-cancel': 'Отмена',
    'geo-points-save': 'Сохранить',
    'geo-points-not-exist': 'Геоточек пока не создано',
    'geo-points-choose': 'Выбрать',
    'geo-code': 'Код',
    'geo-name': 'Название',
    'show-process': 'Диаграмма процесса',
    'delete-item': 'Удалить',
    'delete-order-label': 'Удаление заказа',
    'delete-orders-label': 'Удаление заказа(ов)',
    'delete-order': 'Удалить заказ',
    'delete-orders': 'Удалить заказ(ы)',
    'upload-data-has-errors': 'Имеются ошибки. Данные не могут быть сохранены.',
    'show-errors-only': 'Показать только некорректные',
    'rules': 'Правила техники безопасности при авиаперевозках',
    'rules-error': 'Подтвердите, что согласны с правилами',
    'close': 'Закрыть',
    registered: 'Зарегистрирован',
    group: {
      'd-t-k': 'Дата - Откуда - Куда',
      'd-org': 'Дата - Организация',
      'no-group': 'Без группировки'
    },
    filter: {
      'flight-date-range': 'Дата вылета',
      'flight-date-range-start': 'С',
      'flight-date-range-end': 'По',
      'flight-date-from': 'Вылет с',
      'flight-date-to': 'Вылет по',
      'free-search': 'Поиск',
      'full-match': 'Полное совпадение',
      'organization': 'Организация',
      'initiator': 'Инициатор',
      'priority': 'Приоритет',
      'priority-high': 'Высокий',
      'priority-normal': 'Без приоритета',
      'priority-low': 'Низкий',
      'order-type': 'Тип',
      'order-type-person': 'Люди',
      'order-type-cargo': 'Грузы',
      'order-planned': 'Запланированные',
      'order-not-planned': 'Незапланированные',
      'process-state': 'Статус',
      'hideProcessed': 'Несогласованные'
    },
    'paxList': {
      'num': '#',
      'fullName': 'ФИО',
      'lastName': 'Фамилия',
      'firstName': 'Имя',
      'middleName': 'Отчество',
      'docNum': '№ документа',
      'depPort': 'Из',
      'arrPort': 'В',
      'route': 'Маршрут',
      'birthDate': 'Дата рождения',
      'organization': 'Организация',
      'contacts': 'Контакты',
      'email': 'E-mail',
      mvzsppType: 'Расходы',
      'mvz': 'МВЗ(СПП)',
      'timeFrom': 'Время вылета',
      'status': 'Статус',
      'transportType': 'Способ транспортировки',
      'placeCount': 'Количество мест груза',
      'cargoName': 'Наименование груза',
      'dimensions': 'Габариты и особые свойства груза',
      'weight': 'Масса, кг',
      'packType': 'Вид упаковки',
      'curatorContacts': 'Телефон куратора',
      'curatorEmail': 'E-mail куратора',
      'initiator': 'Инициатор ФИО',
      'initiatorEmail': 'Email инициатора',
      'initiatorPhone': 'Телефон инициатора',
      'depPortId': 'Откуда',
      'arrPortId': 'Куда',
      'rulesAccepted': 'Правила техники безопасности при авиаперевозках',
      'comments': 'Примечание'
    },
    processState: {
      'APPROVING': 'Согласование',
      'SECURITY-APPROVED': 'Утверждено СБ',
      'CURATOR-APPROVED': 'Утверждено куратором',
      'BLACK-LIST-REJECTED': 'Отказ по ЧС',
      'FLIGHT-DATE-TIMEOUT': 'Тайм-аут даты полёта',
      'PROCESSING': 'Согласовано',
      'PLANNED': 'Запланировано',
      'REJECTED': 'Отклонено',
      'FINISHED': 'Завершено',
      'FINISHED-FACT': 'Завершено (факт)',
      'noState': 'Н/Д'
    },
    'notify': {
      'title-order-group-saved': 'Группа заявок',
      'new-order-group-saved-X': 'Группа заявок сохранена {groupId}',
      'order-group-saved': 'Группа заявок сохранена',
      'order-group-published': 'Группа заявок сохранена опубликована',
      'saved-message': 'Заказ(ы) сохранены',
      'uploaded-message': 'Заказы загружены',
      'upload-error-title': 'Ошибка загрузки',
      'upload-error-message': '{exception}',
      'deleted-one-message': 'Заказ удален',
      'deleted-many-message': 'Заказы удалены',
      'fetch-freights-on-date-error': 'Ошибка получения фрахтов на дату',
      'deny-change': {
        approved: 'Заказ уже согласован, для изменения/удаления заказа обратитесь к планирующему',
        planned: 'Заказ запланирован. Для внесения изменений - снимите заказ с рейса',
        finished: 'Обработка заказа завершена'
      }
    },
    'message-box': {
      'remove-group-label': 'Подтвердите действие',
      'remove-group-text': 'Удалить группу заказов и все её заказы?'
    },
    columns: {
      'flightDateString': 'Дата',
      'depPortLabels': {'code': 'Вылет'},
      'arrPortLabels': {'code': 'Прилет'},
      'orderData': {
        'docNum': 'ДОК',
        document: 'Документ',
        'contacts': 'Телефон',
        'phone': 'Телефон',
        'email': 'E-mail',
        //
        'placeCount': 'Мест',
        'name': 'Название',
        'dimensions': 'Габариты',
        'weight': 'Вес',
        //
        'mvz': 'МВЗ/СПП',
        //
        'packType': 'Упаковка',
        'transportType': 'Транспортировка',
        // initiator
        'initiator': 'Инициатор',
        'initiatorEmail': 'Инициатор-email',
        'initiatorPhone': 'Инициатор-тел.',
        //
        'timeFrom': 'Время',
        'fullName': 'ФИО',
        'comments': 'Примечание'
      },
      register: 'Регистрация',
      medcheck: 'Медосмотр',
      //
      'pnr': 'Заказ',
      'shortName': 'ФИО',
      'organization': 'Организация',
      'birthDateStr': 'ДР',
      //
      'processData': {
        'orderStatus': 'Статус'
      },
      tableNameTitle: 'Формат отображения заказов',
      tableName: {
        'flightDateString': 'Дата',
        'depPortLabels': {'code': 'Вылет'},
        'arrPortLabels': {'code': 'Прилет'},
        'orderData': {
          'docNum': 'ДОК',
          'document': 'Документ',
          'contacts': 'Телефон',
          'phone': 'Телефон',
          'email': 'E-mail',
          'placeCount': 'Мест',
          'name': 'Название',
          'dimensions': 'Габариты',
          'weight': 'Вес',
          'mvz': 'МВЗ/СПП',
          'packType': 'Упаковка',
          'transportType': 'Транспортировка',
          'initiator': 'Инициатор',
          'initiatorEmail': 'Инициатор-email',
          'initiatorPhone': 'Инициатор-тел.',
          'timeFrom': 'Время',
          'fullName': 'ФИО (полностью)',
          'comments': 'Примечание'
        },
        register: 'Регистрация',
        medcheck: 'Медосмотр',
        //
        'pnr': 'Заказ',
        'shortName': 'ФИО (сокращённое)',
        'organization': 'Организация',
        'birthDateStr': 'Дата рождения',
        //
        'processData': {
          'orderStatus': 'Статус'
        }
      }
    },
    medcheck: {
      'empty': 'отсутствует',
      'permit-till-X': 'до {date}',
      'end-X': 'истек {date}',
      'not-permit': 'не допущен'
    },
    errors: {
      mvz: 'МВЗ/СПП не определено',
      mvzDate: 'МВЗ/СПП не актуально на дату перевозки',
      depPort: 'Не определен пункт вылета',
      arrPort: 'Не определен пункт прилета',
      initiatorEmail: 'Указан неверный email инициатора',
      organization: 'Организация не найдена',
      notMyOrganization: 'Указана сторонняя организация'
    }
  },
  freight: {
    'title': 'Планирование',
    'approve-title': 'Согласование фрахтов',
    'manage-title': 'Управление фрахтами',
    'finalize-title': 'Завершение фрахтов',
    'create': 'Добавить фрахт',
    'route': 'Маршрут:',
    'empty-route': 'Маршрут не задан',
    'last-update-x': 'изменено: {date}',
    'remove-all-legs': 'Удалить маршрут',
    'delete-freight': 'Удалить фрахт',
    'auto-update-off': 'Автообновление приостановлено',
    'auto-arrange': {
      'replace-all': 'Авторасстановка: замена',
      'append': 'Авторасстановка: добавление',
      'append-initial-locations': 'Авторасстановка: добавление с начальными портами'
    },
    'apply-arrange': 'Сохранить расстановку',
    'cancel-arrange': 'Отменить расстановку',
    'auto-append-orders': 'Распределить оставшиеся заказы',
    'add-faсt-flight': 'Добавить фактический перелет',
    'remove-last-leg': 'Удалить последний пункт',
    'add-leg': 'Добавить пункт',
    'remove-order-item': 'удалить',
    'remove-order-item-not-departed': 'удалить, не вылетел',
    'duration': 'Длительность',
    'durationSmall': 'Длит.',
    'flightType': 'Тип',
    bortType: 'Тип борта',
    filter: {
      portDep: 'Откуда',
      portArr: 'Куда',
      hideFinished: 'Незавершенные'
    },
    'message-box': {
      'submit': 'Подтвердить',
      'cancel': 'Отмена',
      'remove-route-text': 'Удалить весь маршрут фрахта?',
      'delete-freight-text': 'Удалить фрахт?',
      'remove-existed-freights-before-arrange': 'Все существующие расстановки на день будут удалены.'
    },
    notify: {
      'error-on-save-changes': 'Ошибка при сохранении данных фрахта',
      'process-started': 'Процесс запущен',
      'approve-result-submitted': 'Результат согласования передан',
      'finalized-freight': 'Заявка на фрахт исполнена',
      'change-freight-title': 'Изменение фрахта',
      'default-time': 'Установлено время по умолчанию',
      'change-freight': 'Данные фрахта изменены',
      'error-change-time': 'Ошибка сохранения времени',
      'error-change-flight-num': 'Ошибка сохранения номера рейса',
      'error-before-save': 'Не хватает данных для сохранения фрахта'
    },
    flight: {
      'departure-time-plan': 'Вылет (план)',
      'flight-num': 'Номер рейса',
      'departure-time-fact': 'Вылет (факт)',
      'duration': 'Длительность',
      'arrive-time-fact': 'Прибытие (ф)'
    },
    'send-to-approve': 'Передать в работу',
    'send-to-correction': 'Запрос корректировки',
    'show-process': 'Диаграмма процесса',
    'freight-state': 'Статус',
    'action-approve': 'Согласовать',
    'action-reject': 'Отклонить',
    'action-finalize': 'Завершить',
    'documents': 'Документы',
    'report-main': 'Заявка на фрахт',
    'report-details': 'Люди и грузы',
    'change-flight-date': 'Перенос рейса на дату',
    processState: {
      NEW: 'Новая',
      APPROVING: 'Согласование',
      APPROVED: 'Ожидает согласования АК',
      PROCESSING: 'Согласовано',
      REJECTED: 'Отклонено',
      FINISHED: 'Завершено',
      'FLIGHT-DATE-TIMEOUT': 'Тайм-аут даты полёта',
      'FINISHED-FACT': 'Завершено (факт)',
      'APPROVE-CORRECTION': 'Согласование корректировки',
      'CORRECTION-APPROVED': 'Корректировка согласована'
    },
    'ak-manager': {
      'requiredField': 'Обязат. поле',
      'invalidFlightNum': 'Невалидный №'
    }
  },
  'flight-order-groups': {
    security: {
      title: 'Служба безопасности'
    },
    final: {
      title: 'Финальное согласование'
    }
  },
  'special-lists': {
    'title': 'Специальные списки',
    'white-list': 'Список пропусков',
    'black-list': 'Черный список',
    'pax': {
      'code': 'Код',
      'passNum': 'Номер',
      'requestNum': 'Заявка',
      'organization': 'Генподрядчик',
      'fullName': 'ФИО',
      'birthDate': 'Дата рождения',
      'position': 'Должность',
      'subcontractor': 'Субподрядчик',
      'passDateFrom': 'Дата выдачи',
      'passDateTo': 'Действителен до'
    },
    'notify': {
      'saved-message': 'Файл успешно применен'
    }
  },
  flights: {
    title: 'Рейсы',
    flight: 'Рейс',
    without: 'Без рейса',
    commands: {
      'assign-flight': 'Назначить Прин/Отпр',
      'take-flight': 'Взять в обработку',
      'open-registration': 'Открыть регистрацию',
      'close-registration': 'Закрыть регистрацию',
      'start-med-check': 'Начать медосмотр',
      'stop-med-check': 'Закончить медосмотр'
    },
    'order-commands': {
      register: 'Зарегистрировать',
      unregister: 'Снять регистрацию',
      'med-check': 'Медосмотр',
      scan: 'Поиск заказа',
      'scan-title': 'Поиск заказа по QR-коду',
      rescan: 'Повторить',
      'scan-n-register': 'Регистрация',
      'auto-register': 'Автоматическая регистрация',
      'append-passengers': 'Поиск готовых к вылету пассажиров',
      'add-passengers-to-flight': 'Добавить на рейс',
      'add-selected-confirm': 'Добавить выбранных пассажиров на текущий рейс?',
      'remove-from-flight': 'Снять с рейса',
      'remove-from-flight-confirm': 'Снять с рейса выбранные заказы?',
      'send-sms': 'Выслать SMS',
      'download-eticket': 'Скачать квитанцию'
    },
    notify: {
      'passenger-X-registered': 'Пассажир {name} зарегистрирован',
      'passenger-X-unregistered': 'Пассажир {name} снят с регистрации',
      'cargo-X-registered': 'Груз {name} зарегистрирован',
      'cargo-X-unregistered': 'Груз {name} снят с регистрации',
      'passenger-X-medcheck-permit': 'Пассажир {name} медосмотр прошел',
      'passenger-X-medcheck-not-permit': 'Пассажир {name} не прошел медосмотр',
      'passenger-X-invite-to-flighted': 'Пассажиру {name} отправлено SMS',
      'order-not-found': 'Заказ не найден',
      'wrong-code': 'Некорректный QR-код',
      'order-not-found-on-flight': 'На текущем рейсе заказ не найден',
      'order-scanned-yet': 'Код уже отсканирован',
      'camera-not-permitted': 'Необходимо разрешить доступ к камере'
    },
    status: {
      'wait': 'ожидает регистрации',
      'open': 'открыта регистрация',
      'closed': 'регистрация закрыта',
      'med-check': 'медосмотр',
      'departed': 'вылетел',
      'arrived': 'прибыл',
      'expected': 'ожидается'
    },
    medic: {
      'date-till': 'Действительно до',
      permit: 'Прошел',
      'not-permit': 'Не прошел'
    }
  },

  dictionaries: {
    title: 'Справочники'
  },
  dictionary: {
    notify: {
      'saved-message': 'Данные сохранены'
    },
    mvz: {
      title: 'Справочник МВЗ (место возникновения затрат)',
      titleShort: 'Справочник МВЗ',
      code: 'Код МВЗ',
      dateBegin: 'Начало действия МВЗ',
      dateEnd: 'Окончание действия МВЗ',
      comments: 'Комментарии/Наименование МВЗ',
      curators: 'Кураторы'
    },
    spp: {
      title: 'Справочник СПП (структурированный план проекта)',
      titleShort: 'Справочник СПП',
      code: 'Код СПП',
      dateBegin: 'Начало действия СПП',
      dateEnd: 'Окончание действия СПП',
      comments: 'Комментарии/Наименование СПП',
      curators: 'Кураторы'
    },
    'agent-agreements': {
      title: 'Агентские договоры',
      code: 'Номер агентского договора',
      dateBegin: 'Дата начала действия договора',
      dateEnd: 'Окончание действия договора',
      aproc: 'Процент агентского вознаграждения',
      aname: 'Наименование контрагента',
      comments: 'Комментарии',
      curators: 'Кураторы',
      'contains-overlaps-error': 'Имеется пересечение дат для одного договора. Данные не могут быть сохранены.'
    },
    'ak-agreements': {
      title: 'Договоры с авиакомпаниями',
      titleShort: 'Договоры с АК',
      ak: 'Код авиакомпании',
      dateBegin: 'Дата начала действия договора',
      dateEnd: 'Окончание действия договора',
      ts: 'Код типа ВС',
      price: 'Стоимость летного часа',
      comments: 'Комментарии',
      'contains-overlaps-error': 'Имеется пересечение дат. Данные не могут быть сохранены.'
    }
  },
  administration: {
    title: 'Администрирование',
    settings: {
      title: 'Настройки',
      name: 'Наименование',
      description: 'Описание',
      value: 'Значение',
      edit: 'Редактировать',
      confirm: 'Сохранить',
      decline: 'Отменить'
    },
    users: {
      title: 'Пользователи',
      user: 'Пользователь',
      fullName: 'ФИО',
      login: 'Логин',
      role: 'Роли',
      email: 'E-mail',
      phone: 'Телефон',
      ports: 'Порты',
      edit: 'Редактировать',
      editPassword: 'Изменить пароль',
      deletion: 'Удаление',
      delete: 'Удалить',
      deleteModalText: 'Вы точно хотите удалить пользователя',
      cancel: 'Отмена',
      changePassword: 'Изменение пароля',
      newPasswordGeneration: 'Генерация нового пароля',
      generateNewPassword: 'Сгенерировать новый пароль',
      generateNewPasswordFor: 'Сгенерировать новый пароль для',
      changePasswordModalText: 'Новый пароль для',
      submit: 'Подтвердить',
      changeUser: 'Изменение пользователя',
      addUser: 'Добавление пользователя',
      add: 'Добавить',
      freeSearch: 'Свободный поиск',
      invalidEmail: 'Невалидный email',
      invalidDate: 'Невалидная дата',
      invalidPhone: 'Некорретный формат номера, ожидается 79ХХХХХХХХХ',
      existLogin: 'Такой логин существует',
      requiredField: 'Обязательное поле',
      maxLength: 'Превышен лимит вводимых данных',
      useLatin: 'Используйте латинский алфавит',
      companies: 'Компании',
      company: 'Компания',
      organization: 'Организация'
    },
    notification: {
      title: 'Настройка уведомлений',
      sms: 'SMS',
      email: 'Email',
      push: 'Push',
      eventsRoles: 'События\\Роли',
      header: 'Тема сообщения',
      message: 'Сообщение',
      edit: 'Изменить',
      redo: 'Отменить изменения',
      save: 'Сохранить',
      checkboxErrorTitle: 'Ошибка',
      checkboxErrorMessage: 'Невозможно сохранить с пустыми полями'
    }
  },
  reports: {
    title: 'Отчёты',
    'report-gpn': 'Отчёт ГПН',
    'report-agents': 'Отчёт по агентским договорам',
    'report-plan-fact': 'Отчёт план-факт',
    'report-month': 'Месяц',
    'company': 'Компания',
    'report-plan-fact-xlsx': 'Отчёт план-факт в формате Excel',
    'report-plan-fact-pdf': 'Отчёт план-факт в формате PDF',
    'flight-reestr-xlsx': 'Отчёт реестр полётов в формате Excel',
    'flight-reestr-pdf': 'Отчёт реестр полётов в формате PDF',
    'plan-fact': {
      'title': 'Отчет сравнения плана и факта',
      'plan': 'План',
      'fact': 'Факт',
      'helicopters': 'Борты',
      'flights': 'Рейсы',
      'results': 'Итоги'
    }
  },
  // test /////////////////////////////////
  test: {
    'departure-date': 'Departure date',
    'date-range': 'Date range',
    'search': 'Search',
    'cargo': 'Cargo',
    'initiator': 'Initiator',
    'select': 'Select',
    'value-1': 'Value 1',
    'value-2': 'Value 2',
    'value-3': 'Value 3',
    'port': 'Port',
    'plan-fact': {
      'title': 'Отчёт фактический план полётов',
      'plan': 'План',
      'fact': 'Факт',
      'helicopters': 'Борты',
      'flights': 'Рейсы',
      'results': 'Итоги'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/ru.js